var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCameraBlackSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "camera-black-small_svg__a",
  d: "M0 .98h15.833V15H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-952 -950)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ececec",
  fillRule: "nonzero",
  stroke: "#979797",
  d: "M-30.5-36.5h1571v1516h-1571z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M225 198h1198v1086H225z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  x: 942.5,
  y: 941.5,
  fill: "#e6e6e6",
  fillRule: "nonzero",
  stroke: "#e4e4e4",
  rx: 8
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(952 950.02)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "camera-black-small_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#camera-black-small_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#979797",
  d: "M7.917 12.584a3.834 3.834 0 1 1 .001-7.668 3.834 3.834 0 0 1-.001 7.668m5.472-10.167h-1.89L10.376.98H5.75L4.387 2.417H2.445A2.445 2.445 0 0 0 0 4.861v7.694A2.445 2.445 0 0 0 2.445 15h10.944a2.445 2.445 0 0 0 2.445-2.444V4.862a2.445 2.445 0 0 0-2.445-2.445",
  mask: "url(#camera-black-small_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M962.687 958.865a2.77 2.77 0 1 1-5.541 0 2.77 2.77 0 0 1 5.541 0"
}))));
export default SvgCameraBlackSmall;